import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import AccordionItem from './AccordionItem';

import './Accordion.css';

const faqDatas = {
  en: [
    {
      id: 1,
      title: 'What is 1X2?',
      description:
        '1X2 is the dynamic new product of Topaz. The 1X2 product is a competition to correctly predict game results to win the jackpot or pool amount.',
      open: false,
    },
    {
      id: 2,
      title: 'What is a round?',
      description:
        'In the 1X2 game, each product is played weekly in rounds. A round is a form of competition conducted for games played within a predetermined date range.',
      open: false,
    },
    {
      id: 3,
      title: 'How to play Topaz 1X2?',
      description:
        'You can view active rounds on www.topaz1x2.az and create an account to select games within the relevant round. If you believe the home team will win, mark the 1 box. If you think the game will end in a draw, mark the X box. If you predict the away team will win, mark the 2 box. By presenting the validated ticket to the agent, a ticket is created, and by paying the stake amount, you participate in the round.',
      open: false,
    },
    {
      id: 4,
      title: 'What is the jackpot amount?',
      description:
        'If you correctly predict all the games in a round, you will win the predetermined large prize for that round. If multiple players correctly predict all games, the jackpot amount will be shared equally among the winners. If the prize is not won in a round, it carries over to the next rounds until won.',
      open: false,
    },
    {
      id: 5,
      title: 'Can you win the jackpot if one game is postponed?',
      description:
        'No, if you correctly predict 12 out of 13 games and one game is postponed, you do not win the jackpot amount.',
      open: false,
    },
    {
      id: 6,
      title: 'What is the pool amount?',
      description:
        'It is the total amount collected from stakes made by players. The player who correctly predicts the most game outcomes according to the round results is declared the winner and wins the pool amount. In case of an equal number of correct predictions, it is shared among the players.',
      open: false,
    },
    {
      id: 7,
      title: 'What is the minimum stake amount?',
      description:
        'The minimum stake amount is 0.50 AZN. The minimum stake amount can vary depending on the product. Additionally, you can fill all columns both horizontally and vertically without any restrictions. In this case, the stake amount will change accordingly.',
      open: false,
    },
    {
      id: 8,
      title: 'What is the maximum pool amount?',
      description:
        'The maximum pool amount is equal to the total amount collected in the pool. The jackpot amount is not included here, as it is provided separately by Topaz.',
      open: false,
    },
    {
      id: 9,
      title: 'What is a multi-choice stake?',
      description:
        'You can make a multi-choice stake by marking several selections for one game.',
      open: false,
    },
    {
      id: 10,
      title: 'How do you claim a prize?',
      description:
        'You can claim your prize by presenting the physical ticket to the seller at the Topaz terminal. For payments above 3000 AZN, you must come to the Topaz head office with your identity card and the winning physical ticket to collect your prize.',
      open: false,
    },
  ],
  az: [
    {
      id: 1,
      title: '1X2 nədir?',
      description:
        '1X2 Topazın dinamik yeni məhsuludur. 1X2 məhsulu oyun nəticələrini düzgün təxmin edərək cekpot və ya hovuz məbləğini qazanmaq mübarizəsidir.',
      open: false,
    },
    {
      id: 2,
      title: 'Tur nədir?',
      description:
        '1X2 oyununda hər bir məhsul həftəlik olaraq tur şəklində oynanılır. Tur öncədən təyin olunmuş tarix aralığında oynanılan oyunlar üçün mərcin keçirilmə formasıdır.',
      open: false,
    },
    {
      id: 3,
      title: 'Topaz 1X2 necə oynanılır?',
      description:
        'Siz www.topaz1x2.az saytında  aktiv olan turları görə və hesab yaradaraq müvafiq tura daxil olan oyunları seçə bilərsiniz. Əgər ev sahibi komandanın qazanacağına inanırsınızsa 1 qutusunu işarələyin. Əgər oyunun heç-heçə bitəcəyini düşünürsünüzsə X qutusunu, yox qonaq komanda qazanacaq deyirsinizsə  2 qutusunu işarələyin. Bron edilmiş kupon ilə agentə yaxınlaşaraq barkodu oxutdurduqda bilet yaranır və mərc məbləğini ödəyərək mərc oyununda iştirak etmiş olursunuz.',
      open: false,
    },
    {
      id: 4,
      title: 'Cekpot məbləği nədir?',
      description:
        'Əgər siz turda verilən bütün oyunları düz təxmin etsəniz, tur üçün öncədən təyin olunmuş böyük  mükafatı qazanacaqsınız. Bir neçə oyunçu bütün oyunları düz təxmin edərsə, cekpot məbləği oyunçular arasında bərabər bölüşdürüləcək. Mükafatın məbləği bir turda qazanılmadığı halda, növbəti turda oynanılır və qazanılanadək növbəti turlara ötürələcəkdir.',
      open: false,
    },
    {
      id: 5,
      title: '1 oyun təxirə gedərsə Cekpot qazanılırmı?',
      description:
        'Xeyr, əgər 13 oyundan 12-ni bilmisinizsə və 1 oyun təxirə gedibsə bu zaman Cekpot məbləği qazanılmır.',
      open: false,
    },
    {
      id: 6,
      title: 'Hovuz məbləği nədir?',
      description:
        'Oyunçular tərəfindən edilən mərclərə əsasən yığılan uduş məbləğidir. Turun nəticələrinə görə ən çox düzgün oyun proqnoz etmiş iştirakçı qalib sayılır və hovuz məbləğini qazanır. Eyni anda ən çox bərabər sayda düzgün proqnoz tapan oyunçular arasında bölünür.',
      open: false,
    },
    {
      id: 7,
      title: 'Minimum mərc məbləği nə qədərdir?',
      description:
        'Minimum mərc məbləği şərti olaraq 0.50 AZN-dir. Minimum mərc məbləği məhsula görə dəyişə bilər. Bundan əlavə, heç bir məhdudiyyət qoyulmadan siz istənilən oyunda həm üfüqi, həm də şaquli istiqamətdə bütün sütunları doldura bilərsiniz. Bu zaman mərc məbləği müvafiq olaraq dəyişəcəkdir.',
      open: false,
    },
    {
      id: 8,
      title: 'Maximum uduş məbləği?',
      description:
        'Maximum uduş məbləği hovuza yığılan məbləğə bərabərdir. Cekpot məbləği bura daxil deyildir. Cekpot məbləği Topaz tərəfindən təqdim olunur.',
      open: false,
    },
    {
      id: 9,
      title: 'Çoxvariantlı mərc nədir?',
      description:
        'Siz bir oyun üçün bir neçə xananı işarələyərək çoxvariantlı mərc edə bilərsiniz.',
      open: false,
    },
    {
      id: 10,
      title: 'Uduş necə əldə olunur?',
      description:
        'Topaz məntəqəsinə yaxınlaşaraq fiziki bileti satıcıya təqdim edərək uduş mükafatını əldə edə bilərsiniz. 3000 AZN-dən yuxarı ödənişlərdə şəxsiyyət vəsiqəsi və uduşlu fiziki biletlə birlikdə Topaz baş ofisinə gələrək uduş mükafatını alırsınız.',
      open: false,
    },
  ],
  ru: [
    {
      id: 1,
      title: 'Что такое 1X2?',
      description:
        '1X2 - это динамичный новый продукт Topaz. Продукт 1X2 представляет собой конкурс по правильному предсказанию результатов игр для выигрыша джекпота или суммы пула.',
      open: false,
    },
    {
      id: 2,
      title: 'Что такое раунд?',
      description:
        'В игре 1X2 каждый продукт играется еженедельно в раундах. Раунд - это форма соревнования, проводимая для игр, сыгранных в предопределенный период времени.',
      open: false,
    },
    {
      id: 3,
      title: 'Как играть в Topaz 1X2?',
      description:
        'Вы можете просматривать активные раунды на сайте www.topaz1x2.az и создать учетную запись для выбора игр в соответствующем раунде. Если вы считаете, что домашняя команда победит, отметьте галочкой поле 1. Если вы считаете, что игра закончится вничью, отметьте галочкой поле X. Если вы предсказываете победу гостевой команды, отметьте галочкой поле 2. Предъявив проверенный билет агенту, создается билет, и, выплатив ставку, вы участвуете в раунде.',
      open: false,
    },
    {
      id: 4,
      title: 'Что такое джекпот?',
      description:
        'Если вы правильно предсказываете все игры в раунде, вы выигрываете предварительно определенный крупный приз за этот раунд. Если несколько игроков правильно предсказывают все игры, джекпот делится поровну между победителями. Если приз не выигран в раунде, он переносится на следующие раунды, пока не будет выигран.',
      open: false,
    },
    {
      id: 5,
      title: 'Можно ли выиграть джекпот, если одна игра отложена?',
      description:
        'Нет, если вы правильно предсказываете 12 из 13 игр и одна игра отложена, вы не выигрываете сумму джекпота.',
      open: false,
    },
    {
      id: 6,
      title: 'Что такое сумма пула?',
      description:
        'Это общая сумма, собранная от ставок, сделанных игроками. Игрок, который правильно предсказывает большее количество результатов игр согласно результатам раунда, объявляется победителем и выигрывает сумму пула. В случае равного количества правильных предсказаний сумма делится между игроками.',
      open: false,
    },
    {
      id: 7,
      title: 'Какова минимальная сумма ставки?',
      description:
        'Минимальная сумма ставки составляет 0,50 AZN. Минимальная сумма ставки может варьироваться в зависимости от продукта. Кроме того, вы можете заполнить все столбцы как по горизонтали, так и по вертикали без каких-либо ограничений. В этом случае сумма ставки изменится соответственно.',
      open: false,
    },
    {
      id: 8,
      title: 'Что такое максимальная сумма пула?',
      description:
        'Максимальная сумма пула равна общей сумме, собранной в пуле. Сумма джекпота здесь не включается, поскольку она предоставляется отдельно Topaz.',
      open: false,
    },
    {
      id: 9,
      title: 'Что такое мульти-выбор ставки?',
      description:
        'Вы можете сделать мульти-выбор ставки, отметив несколько вариантов для одной игры.',
      open: false,
    },
    {
      id: 10,
      title: 'Как получить приз?',
      description:
        'Вы можете получить свой приз, предъявив физический билет продавцу на терминале Topaz. Для выплат выше 3000 AZN вам необходимо прийти в главный офис Topaz с вашим удостоверением личности и выигрышным физическим билетом.',
      open: false,
    },
  ],
};

const Accordion = () => {
  const [data, setData] = useState(faqDatas.en);

  const { lang } = useSelector((state) => state.lang);

  const handleClick = (index) => () => {
    setData((prevState) =>
      prevState.map((item, idx) => {
        if (index === idx) {
          return { ...item, open: !item.open };
        }
        return { ...item, open: false };
      })
    );
  };

  useEffect(() => {
    faqDatas[lang] && setData(faqDatas[lang]);
  }, [lang]);

  return (
    <div className="accordion">
      {data.map((item, index) => (
        <AccordionItem
          key={item.id}
          title={item.title}
          description={item.description}
          onClick={handleClick(index)}
          open={item.open}
        />
      ))}
    </div>
  );
};

export default Accordion;
